"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FollowUs = void 0;
var _mui = require("@ori-ui/mui");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _react = _interopRequireDefault(require("react"));
var _hooks = require("../../hooks");
var _components = require("./components");
var _constants = require("./constants");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const FollowUs = () => {
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  const {
    translations
  } = (0, _hooks.useTranslations)();
  const {
    socialMediaLinks
  } = (0, _hooks.useFooter)();
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.FollowUsRoot, {
    "data-testid": getTestId(_constants.FOLLOW_US),
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Typography, {
      component: "p",
      variant: "h5",
      children: translations.followUs
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Icons, {
      children: socialMediaLinks.map(({
        type,
        title,
        url
      }, index) => /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.SocialMediaIcon, {
        type: type,
        title: title,
        url: url
      }, title ?? index))
    })]
  });
};
exports.FollowUs = FollowUs;